import { SideNavInterface } from '../../interfaces/side-nav.type';
export const ROUTES: SideNavInterface[] = [
    {
        path: 'dashboard/home',
        title: 'Dashboard',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'home',
        roles: ['1', '2', '3'],
        submenu: []
    },
    // {
    //     path: 'reports/file-type-analysis',
    //     title: 'File Type Summary',
    //     iconType: 'nzIcon',
    //     iconTheme: 'outline',
    //     icon: 'bar-chart',
    //     roles: ['1', '2', '3'],
    //     submenu: []
    // },
    {
        path: 'user/project-list',
        title: 'Project List',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'appstore-add',
        roles: ['1', '2', '3'],
        submenu: []
    },
    
    {
        path: '',
        title: 'Reports',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'container',
        roles: ['1', '2','3'],
        submenu: [
            {
                path: 'reports/file-analysis-report',
                title: 'File Analysis Report',
                iconType: '',
                icon: 'unordered-list',
                iconTheme: '',
                roles: ['1', '2','3'],
                submenu: []
            },
             {
                path: 'reports/cs-ir-report',
                title: 'CS/IR Report',
                iconType: '',
                icon: 'unordered-list',
                iconTheme: '',
                roles: ['1', '2','3'],
                submenu: []
            }
        ]
     }
]    